import { Pipe, PipeTransform } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { ByteSizePipe } from './byte-size/byte-size.pipe';

@Pipe({
  name: 'uploadError'
})
export class UploadErrorPipe implements PipeTransform {
  transform(errors: ValidationErrors, index: number): string {
    return this.getErrorMessage(errors, index);
  }

  getErrorMessage(errors: ValidationErrors, index: number): string {
    if (!errors) {
      return;
    }
    if (errors.indices && errors.indices.includes(index)) {
      if (errors.minSize) {
        return `File must be greater than ${new ByteSizePipe().transform(errors.minSize)}`;
      }
      if (errors.maxSize) {
        return `File exceeds maximum size of ${new ByteSizePipe().transform(errors.maxSize)}`;
      }
      if (errors.fileTypes) {
        return `Invalid file type. Only ${errors.fileTypes.join(', ')} allowed.`;
      }
    }
  }
}
